var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-no-useless-fragment */
import React from 'react';
import { useModal, TripType, HotelExtraType, HotelPriceIncludesType, HypeType, useGlobalContext, useSearch, } from '@honeycomb/data';
import { BusAndCarIcon, GroupIcon, InfoItem, InfoItems, KnifeAndForkIcon, MoonIcon, PercentageIcon, PlaneIcon, ShieldIcon, Skeleton, Stacker, TagIcon, TypographyBody, } from '@honeycomb/ui-core';
import { getOccupancySummary } from '../../../utils/getOccupancySummary';
import { getFormattedStartDate } from '../../../utils/formatDate';
const getIcon = (item) => {
    switch (item) {
        case HotelPriceIncludesType.RETURN_FLIGHTS:
            return React.createElement(PlaneIcon, null);
        case HotelPriceIncludesType.NIGHTS_COUNT:
            return React.createElement(MoonIcon, null);
        case HotelPriceIncludesType.BOARD_BASIS:
            return React.createElement(KnifeAndForkIcon, null);
        case HotelPriceIncludesType.STAY_COUNT:
            return React.createElement(GroupIcon, null);
        case HotelPriceIncludesType.LOCAL_CHARGES:
            return React.createElement(PercentageIcon, null);
        case HotelPriceIncludesType.MANDATORY_TRANSFER:
            return React.createElement(BusAndCarIcon, null);
        case HypeType.Amendable:
        case HypeType.Nonrefundable:
            return React.createElement(ShieldIcon, null);
        default:
            return React.createElement(TagIcon, null);
    }
};
export function HotelPriceIncludes(_a) {
    var _b;
    var { pricingSummary, typesToDisplay: items, onFlightDetailsClick, hasFlight = false, hideIcons = false, loading: loadingProp = false, ItemProps } = _a, other = __rest(_a, ["pricingSummary", "typesToDisplay", "onFlightDetailsClick", "hasFlight", "hideIcons", "loading", "ItemProps"]);
    const { resourceStrings: { ADULT, ADULTS, CHILD, CHILDREN, HC_HOTELLOCALCHARGES, LOCALCHARGES_DESCRIPTION, LOCALCHARGES_HEADING, LOCALCHARGES, NIGHT, HC_HOTEL_NIGHTS, RETURNFLIGHTS, ROOM, ROOMS, TRANSFER_INCLUSION_MESSAGE, LOCALCHARGES_EXCHANGERATE_INFO, }, configSettings: { FlightSelectionExtended }, } = useGlobalContext();
    const [hotelSearch, _] = useSearch([]);
    const [_currentModal, setCurrentModal] = useModal();
    const loading = loadingProp || !pricingSummary;
    if (loading) {
        // Skeleton
        return (React.createElement(Stacker, { spacing: 2 }, ['55%', '40%', '60%', '70%', '50%'].map((width) => {
            return (React.createElement(TypographyBody, { component: "div", size: "s", key: width },
                React.createElement(Skeleton, { variant: "text", w: width })));
        })));
    }
    const { rooms, tripType } = hotelSearch;
    const isHoliday = tripType === TripType.Holiday;
    const hasMandatoryTransfer = (_b = pricingSummary.includedExtras) === null || _b === void 0 ? void 0 : _b.some((extras) => extras === HotelExtraType.Transfer);
    const showNightCount = FlightSelectionExtended === 'true';
    const roomContent = getOccupancySummary(rooms, { ADULT, ADULTS, CHILD, CHILDREN, ROOM, ROOMS });
    const priceIncludeItems = !pricingSummary
        ? [
            HotelPriceIncludesType.STAY_COUNT,
            HotelPriceIncludesType.LOCAL_CHARGES,
            HotelPriceIncludesType.MANDATORY_TRANSFER,
            HotelPriceIncludesType.RETURN_FLIGHTS,
            HotelPriceIncludesType.NIGHTS_COUNT,
        ]
        : items;
    const { numberOfNights } = pricingSummary;
    const handleClick = (values) => {
        const { heading, subheading, body } = values;
        setCurrentModal({
            isOpen: true,
            heading,
            subheading,
            body,
        });
    };
    const formattedStartDate = getFormattedStartDate(pricingSummary, hotelSearch);
    return (React.createElement(InfoItems, Object.assign({}, other), priceIncludeItems === null || priceIncludeItems === void 0 ? void 0 : priceIncludeItems.map((item) => {
        var _a;
        switch (item) {
            case HotelPriceIncludesType.RETURN_FLIGHTS:
                return (isHoliday &&
                    hasFlight && (React.createElement(InfoItem, Object.assign({ onClick: onFlightDetailsClick, button: !!onFlightDetailsClick, icon: (!hideIcons && getIcon(item)) || undefined }, ItemProps, { "data-id": "return_flights", key: HotelPriceIncludesType.RETURN_FLIGHTS }), RETURNFLIGHTS)));
            case HotelPriceIncludesType.NIGHTS_COUNT:
                return (showNightCount &&
                    numberOfNights && (React.createElement(InfoItem, Object.assign({ icon: (!hideIcons && getIcon(item)) || undefined }, ItemProps, { "data-id": "nights", key: HotelPriceIncludesType.NIGHTS_COUNT }), `${formattedStartDate} - ${numberOfNights} ${numberOfNights <= 1 ? NIGHT : HC_HOTEL_NIGHTS}`)));
            case HotelPriceIncludesType.BOARD_BASIS:
                return (pricingSummary.boardTypeDescription && (React.createElement(InfoItem, Object.assign({ icon: (!hideIcons && getIcon(item)) || undefined }, ItemProps, { "data-id": "room_description", key: HotelPriceIncludesType.BOARD_BASIS }), pricingSummary.boardTypeDescription)));
            case HotelPriceIncludesType.STAY_COUNT:
                return (React.createElement(InfoItem, Object.assign({ icon: (!hideIcons && getIcon(item)) || undefined }, ItemProps, { "data-id": "room_content", key: HotelPriceIncludesType.STAY_COUNT }), roomContent));
            case HotelPriceIncludesType.LOCAL_CHARGES:
                return (pricingSummary.cityTaxFormatted &&
                    !isHoliday && (React.createElement(InfoItem, Object.assign({ icon: (!hideIcons && getIcon(item)) || undefined }, ItemProps, { button: true, onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleClick({
                            heading: LOCALCHARGES_HEADING,
                            body: `
                                                <p>${LOCALCHARGES}: <strong>${pricingSummary.cityTaxFormatted}</strong></p>
                                                <p>${LOCALCHARGES_DESCRIPTION} ${LOCALCHARGES_EXCHANGERATE_INFO}</p>`,
                        });
                    }, "data-id": "id_local_charge_hyperlink", key: HotelPriceIncludesType.LOCAL_CHARGES }), HC_HOTELLOCALCHARGES)));
            case HotelPriceIncludesType.HYPE_MESSAGES:
                return (_a = pricingSummary.hypeMessages) === null || _a === void 0 ? void 0 : _a.map(({ title, type, description, descriptionHeader }, index) => (React.createElement(InfoItem, Object.assign({ icon: (!hideIcons && getIcon(type)) || undefined, button: description !== null, onClick: (e) => {
                        if (description && descriptionHeader) {
                            e.preventDefault();
                            e.stopPropagation();
                            handleClick({ heading: descriptionHeader, body: description });
                        }
                    } }, ItemProps, { "data-id": `id_hypemessage_${index}`, key: type }), title)));
            case HotelPriceIncludesType.MANDATORY_TRANSFER:
                return (hasMandatoryTransfer && (React.createElement(InfoItem, Object.assign({ icon: (!hideIcons && getIcon(item)) || undefined }, ItemProps, { key: HotelPriceIncludesType.MANDATORY_TRANSFER }), TRANSFER_INCLUSION_MESSAGE)));
            default:
                return null;
        }
    })));
}
